var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from 'react';
import { ArrowChevronLeft, ArrowChevronRight } from '../../icons';
import { IconButton } from '../IconButton';
import { TabBar as Wrapper } from './TabBar.styles';
export var TabBar = function (props) {
    var _a = props.current, defaultCurrent = _a === void 0 ? 0 : _a, _b = props.show, defaultShow = _b === void 0 ? 5 : _b, _c = props.thin, defaultThin = _c === void 0 ? false : _c;
    var children = props.children;
    var _d = useState(defaultCurrent), current = _d[0], setCurrent = _d[1];
    var _e = useState(defaultShow), show = _e[0], setShow = _e[1];
    var tabs = React.Children.map(children, function (child, index) {
        return React.cloneElement(child, __assign(__assign({}, child.props), { thin: defaultThin, hide: index >= show && current < show, current: index === current, onClick: function () {
                setCurrent(index);
                if (child.props.onClick !== undefined) {
                    child.props.onClick();
                }
            } }));
    });
    var toggleExpander = function () {
        setShow(show === tabs.length ? defaultShow : tabs.length);
    };
    return (React.createElement(Wrapper, __assign({}, props),
        tabs,
        tabs.length > defaultShow ? (React.createElement(IconButton, { small: defaultThin, icon: show === tabs.length ? React.createElement(ArrowChevronLeft, null) : React.createElement(ArrowChevronRight, null), disabled: current >= defaultShow, onClick: toggleExpander })) : null));
};
//# sourceMappingURL=TabBar.js.map